<div *ngIf="isLoading">
    <div class="popup-overlay"></div>
    <div class="popup-wrapper"></div>
    <img src="assets/images/loading.gif" class="loadingContainer" alt="">
    <!-- <mat-progress-spinner mode="indeterminate" class="loadingContainer"></mat-progress-spinner> -->
</div>
